import { Modal, ModalContent, ModalHeader, ModalBody } from "@nextui-org/react";

interface ViewsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  viewCount: number;
}

export const ViewsModal = ({
  open,
  onOpenChange,
  viewCount
}: ViewsModalProps) => {
  return (
    <Modal
      isOpen={open}
      onOpenChange={onOpenChange}
      size="sm"
      className="bg-secondary"
    >
      <ModalContent>
        <ModalHeader className="text-xl">Views</ModalHeader>
        <ModalBody className="pb-6">
          <p className="text-default-500">
            This post has been viewed {viewCount} {viewCount === 1 ? 'time' : 'times'}.
          </p>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ViewsModal;